import { render, staticRenderFns } from "./EstateData.vue?vue&type=template&id=d525a04c&"
import script from "./EstateData.vue?vue&type=script&lang=js&"
export * from "./EstateData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports